import React, { Component } from "react";
import {
  Panel,
  Form,
  FormField,
  LinkButton,
  PasswordBox,
  Messager,
} from "rc-easyui";
import setTitle from "../../../helpers/TitleComponent";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { logout } from "../../../helpers/index";
import { API_URL } from "../../../constants";

const axios = require("axios");

export default class ChangePassword extends Component {
  constructor() {
    super();
    this.state = {
      user: {
        username: getCookie("username"),
        oldpassword: null,
        newpassword: null,
        confirm_password: null,
      },
      rules: {
        oldpassword: {
          required: true,
          passwordCriteria: {
            validator(value) {
              const regx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,}$)/;
              return regx.test(value);
            },
            message:
              "Password field must have atleast 1 Speical , 1 Small , 1 capital , 1 Numeric Character and Minimum 8 charcter length",
          },
        },
        newpassword: {
          required: true,
          passwordCriteria: {
            validator(value) {
              const regx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,}$)/;
              return regx.test(value);
            },
            message:
              "Confirm Password field must have atleast 1 Speical , 1 Small , 1 capital , 1 Numeric Character and Minimum 8 charcter length",
          },
        },
        confirm_password: {
          required: true,
          passwordCriteria: {
            validator(value) {
              const regx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,}$)/;
              return regx.test(value);
            },
            message:
              "Confirm Password field must have atleast 1 Speical , 1 Small , 1 capital , 1 Numeric Character and Minimum 8 charcter length",
          },
        },
      },
      errors: {},
      permissions: [],
      isLoading: false,
    };
  }

  componentDidMount() {
    var data = getCookie("permission");
    this.setState(
      {
        permissions: JSON.parse(data),
      },
      function () {
        setTitle("Change Password");
      }
    );
  }

  handleChange(name, value) {
    let user = Object.assign({}, this.state.user);
    user[name] = value;
    //console.log("user[name]",name,user["oldpassword"])
    if (name === "newpassword" && user[name] === user["oldpassword"]) {
      alert("Please try new one !");
      user[name] = "";
    }
    this.setState({ user: user });
  }

  async handleSubmit() {
    this.setState({
      isLoading: true,
    });
    let token = getCookie("access_token");
    if (JSON.stringify(token) === "null") {
      const resp = await getAccessToken();
      if (resp) {
        this.changePassword();
      }
    } else {
      this.changePassword();
    }
  }

  changePassword() {
    let tokenType = getCookie("token_type");
    let token = getCookie("access_token");
    this.form.validate((errors) => {
      if (errors) {
        this.setState({
          isLoading: false,
        });
        alert("Please fill the required validations");
      } else {
        let apiData = this.state.user;
        let apiUrl = `${API_URL}api/changepassword`;
        let headersConfig = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${tokenType} ${token}`,
          },
        };
        let self = this;
        axios
          .post(apiUrl, apiData, headersConfig)
          .then(function (response) {
            //console.log("response",response);
            if (response.status === 200) {
              if (response.data !== "") {
                if (response.data.status === true) {
                  self.setState({
                    isLoading: false,
                  });
                  logout();
                } else {
                  self.setState({
                    isLoading: false,
                  });
                  self.messager.alert({
                    title: "Error",
                    msg: `${response.data.message}`,
                    reload: false,
                  });
                }
              } else {
                self.setState({
                  isLoading: false,
                });
                self.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                });
              }
            } else {
              self.setState({
                isLoading: false,
              });
              self.messager.alert({
                title: "Error",
                msg: "Internal Server Error",
                reload: false,
              });
            }
          })
          .catch(function (error) {
            //console.log("error",error);
            let response = error["response"];
            if (response !== undefined) {
              if (response.status === 400) {
                var message = "";
                response.data.errors.forEach((row, i) => {
                  message +=
                    "<p style='margin-bottom:3px;'>" +
                    row.defaultMessage +
                    "</p>";
                });
                self.messager.alert({
                  title: "Error",
                  msg: message,
                  reload: false,
                });
              } else {
                self.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            } else {
              self.messager.alert({
                title: "Error",
                msg: "Internal Server Error",
                reload: false,
              });
            }
            self.setState({
              isLoading: false,
            });
          });
      }
    });
  }

  render() {
    const { user, rules, permissions } = this.state;
    return (
      <div className='container-fluid'>
        <div className='row'>
          {permissions.includes("reset-password") ? (
            <div className='col-5 '>
              <Panel title='Change Password' bodyStyle={{ padding: 20 }}>
                <Messager
                  ref={(ref) => (this.messager = ref)}
                  showHeader={false}
                  borderType='none'
                  content={({ title, msg, buttons, reload }) => (
                    <div className='alert-content'>
                      <h3>{title}</h3>
                      <div
                        style={{ marginBottom: 5 }}
                        dangerouslySetInnerHTML={{ __html: msg }}
                      ></div>
                      <div className='m-buttons'>
                        {buttons.map((button, index) => (
                          <LinkButton
                            key={index}
                            text={button.text}
                            onClick={() => {
                              this.messager.close(button);
                              if (reload) {
                                window.location.reload();
                              }
                            }}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                />
                <Form
                  ref={(ref) => (this.form = ref)}
                  style={{ maxWidth: 500 }}
                  model={user}
                  labelWidth={150}
                  labelAlign='left'
                  rules={rules}
                  onChange={this.handleChange.bind(this)}
                  onValidate={(errors) => this.setState({ errors: errors })}
                >
                  <FormField name='oldpassword' label='Old Password:'>
                    <PasswordBox></PasswordBox>
                  </FormField>
                  <FormField name='newpassword' label='New Password:'>
                    <PasswordBox></PasswordBox>
                  </FormField>
                  <FormField name='confirm_password' label='Confirm Password:'>
                    <PasswordBox></PasswordBox>
                  </FormField>
                  <FormField
                    style={{ marginLeft: 150, marginRight: 10, marginTop: 40 }}
                  >
                    <LinkButton onClick={this.handleSubmit.bind(this)}>
                      Change Password
                    </LinkButton>
                  </FormField>
                </Form>
              </Panel>
            </div>
          ) : (
            <div>You are not allowed to access this module.</div>
          )}
        </div>
      </div>
    );
  }
}
